import React from 'react';

export const SKELETON_CSS = `
  @keyframes skel-shimmer{0%{background-position:-400px 0;}100%{background-position:400px 0;}}
  .skel-block{background:linear-gradient(90deg,#EEEEEE 25%,#F6F6F6 37%,#EEEEEE 63%);background-size:800px 100%;animation:skel-shimmer 1.4s ease-in-out infinite;border-radius:6px;}
`;

const Skeleton = ({ width = '100%', height = 14, radius = 6, style = {} }) => (
  <div className="skel-block" style={{ width, height, borderRadius: radius, ...style }} />
);

export default Skeleton;
